import gql from 'graphql-tag'

import {
	standardJobResult,
	jobApplicantsConnectionData,
	jobConnectionData,
} from 'store/fragments'
import { pageInfoData } from '../fragments/common'

// QUERIES
export const JobQuery = gql`
	query jobQuery($filter:  JobFilter) {
		jobCollection(filter: $filter) {edges{node{
			...standardJobResult
		}}}
	}
	${standardJobResult}
`

export const FeedJobsQuery = gql`
	query feedJobs(
  $name: String
  $companyname: String
  $companyslug: String
  $teamname: String
  $locationsids: [String]
  $departmentids: [String]
  $sizes: [String]
  $salarymin: String
  $salarymax: String
  $typeofjob: [String]
  $senioritylevels: [String]
  $currency: String
  $contracttypes: [String]
  $locationtypes: [String]
  $skills: [String]
  $first: Int
  $last: Int
  $before: Cursor
  $after: Cursor
  $offset: Int
  $filter: JobFilter
  $orderBy: [JobOrderBy!]
) {
  feedjobs(
    name: $name
    companyname: $companyname
    companyslug: $companyslug
    teamname: $teamname
    locationsids: $locationsids
    departmentids: $departmentids
    sizes: $sizes
    salarymin: $salarymin
    salarymax: $salarymax
    typeofjob: $typeofjob
    senioritylevels: $senioritylevels
    currency: $currency
    contracttypes: $contracttypes
    locationtypes: $locationtypes
    skills: $skills
    first: $first
    last: $last
    before: $before
    after: $after
    offset: $offset
    filter: $filter
    orderBy: $orderBy
  )  {
			edges{node{...jobConnectionData}
				cursor}
					pageInfo {
			...pageInfoData
		}
		}
	}
	${jobConnectionData}
	${pageInfoData}

`
export const FeedJobApplicantsQuery = gql`
	query feedJobApplicants(
		$jobId: String
$applicantName: String
$applicationDateStart: String
$applicationDateEnd: String
$first: Int
$last: Int
$before: Cursor
$after: Cursor
$offset: Int
	) {
		feedJobApplicants(
				jobId:$jobId
applicantName:$applicantName
applicationDateStart:$applicationDateStart
applicationDateEnd:$applicationDateEnd
first:$first
last:$last
before:$before
after:$after
offset:$offset
		) {
		...jobApplicantsConnectionData
		}
	}
	${jobApplicantsConnectionData}
`

// MUTATIONS
export const ApplyJob = gql`
	mutation applyJob(
		# $language: LanguageCodeType!
		$id: String!
		# $isApplying: Boolean!
	) {
		insertIntoJobApplicantCollection(
			objects:{# language: $language
			 id: $id
			#  isApplying: $isApplying
			} ) {
	 affectedCount
    records{
      id
      nodeId
    }
		}
	}
`

export const PostJob = gql`
	mutation insertIntoJobCollection($data: [JobInsertInput!]!) {
		insertIntoJobCollection(objects: $data) {
			records{...standardJobResult}
		}
	}
	${standardJobResult}
`
export const EditJob = gql`
	mutation updateJobCollection($data:  JobUpdateInput!) {
		updateJobCollection(set: $data) {
			records{...standardJobResult}
		}
	}
	${standardJobResult}
`

export const DeleteJob = gql`
	mutation deleteJob($data: JobFilter!) {
		deleteFromJobCollection(filter: $data) {
			records{...standardJobResult}
		}
	}
	${standardJobResult}
`
